var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 63,
    viewBox: "0 0 76 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 62.4471L38 0.218262L75.5 62.4471H0.5ZM9.36364 57.5343H66.6364L38 10.0439L9.36364 57.5343ZM38.3409 52.8671C39.0795 52.8671 39.6903 52.6351 40.1733 52.1711C40.6562 51.7072 40.8977 51.1203 40.8977 50.4107C40.8977 49.7011 40.6562 49.1143 40.1733 48.6503C39.6903 48.1863 39.0795 47.9543 38.3409 47.9543C37.6023 47.9543 36.9915 48.1863 36.5085 48.6503C36.0256 49.1143 35.7841 49.7011 35.7841 50.4107C35.7841 51.1203 36.0256 51.7072 36.5085 52.1711C36.9915 52.6351 37.6023 52.8671 38.3409 52.8671ZM35.7841 43.7784H40.8977V25.4373H35.7841V43.7784Z",
    fill: "#D8231B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.b72fdfa4613ac8567ce2c4cb63d76b14.svg";
export { ForwardRef as ReactComponent };